import downloadIcon from "../../Resources/Image/sd-download.svg";

const csvRowHeader = ["Date", "Company Name", "Delivery Fees($)", "Tips($)", "Regulatory Fee($)", "Third Party Total($)", "Paid Amount($)", "Outstanding Amount($)"];

export const getThirdPartyUsageCSVDataLink = (fileName, date, weeklyBillingData, accountData) => {
    fileName += ".csv";
    let blob = new Blob([createCSVRows(date, weeklyBillingData, accountData)], {type: "text/csv"});
    let url = window.URL.createObjectURL(blob);
    return <a className="downloadBtn" href={url} download={fileName} title={"Download Details"}><img
        src={downloadIcon} alt="download"/></a>;
}

const createCSVRows = (date, weeklyBillingData, accountData) => {
    let rowString = csvRowHeader.join(",");
    rowString += "\n";
    weeklyBillingData.forEach((entry) => {
        let row = [];
        let companyName = sanitize(accountData[entry.companyId].companyName);
        let delivery = Number(entry.deliveryFeeAmount).toFixed(2);
        let tips = Number(entry.tipsAmount).toFixed(2);
        let regulatoryFee = Number(entry.regulatoryFee).toFixed(2);
        let total = Number(entry.totalAmount).toFixed(2);
        let paid = Number(entry.paidAmount).toFixed(2);
        let unpaid = Number(entry.unpaidAmount).toFixed(2);
        row.push(date, companyName, delivery, tips, regulatoryFee, total, paid, unpaid);
        let newRow = row.join(",");
        rowString += newRow + "\r\n";
    })
    return rowString;
}

export const sanitize = (str = "") => {
    return String(str).replaceAll(",", " ");
}

const formatCurrency = (value) => {
    const number = Number(value ?? 0);
    return Number.isNaN(number) ? "0.00" : number.toFixed(2);
}

const getCompanyNameFromEntry = (entry = {}) => {
    return (
        entry.companyName ||
        entry.thirdPartyName ||
        entry.accountName ||
        entry.company?.name ||
        entry.name ||
        entry.identifier ||
        ""
    );
}

const extractThirdPartyDetailEntries = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.thirdPartyDetails)) return payload.thirdPartyDetails;
    if (Array.isArray(payload.billingInfos)) return payload.billingInfos;
    if (Array.isArray(payload.details)) return payload.details;
    if (payload.thirdPartyDetails && Array.isArray(payload.thirdPartyDetails.billingInfos)) {
        return payload.thirdPartyDetails.billingInfos;
    }
    if (Array.isArray(payload.detailEntries)) return payload.detailEntries;
    return [];
}

const createThirdPartyUsageCSVContent = (date, thirdPartyDetailsPayload) => {
    const entries = extractThirdPartyDetailEntries(thirdPartyDetailsPayload);
    let rowString = csvRowHeader.join(",");
    rowString += "\n";
    const formattedDate = date ?? "";

    entries.forEach((entry) => {
        const row = [
            formattedDate,
            sanitize(getCompanyNameFromEntry(entry)),
            formatCurrency(entry.deliveryFeeAmount ?? entry.deliveryFee ?? entry.delivery),
            formatCurrency(entry.tipsAmount ?? entry.tips ?? entry.tipAmount),
            formatCurrency(
                entry.regulatoryFee ?? entry.regulatoryFeeAmount ?? entry.regulatoryFees
            ),
            formatCurrency(entry.totalAmount ?? entry.total),
            formatCurrency(entry.paidAmount ?? entry.paid),
            formatCurrency(entry.unpaidAmount ?? entry.unpaid)
        ];
        rowString += row.join(",") + "\r\n";
    });
    return rowString;
}

export {createThirdPartyUsageCSVContent};
